import { ChangeDetectionStrategy, Component, computed, effect, input } from '@angular/core';

import { NumpadService } from '../../../../../../../lib/numpad/numpad.service';
import { BetslipType } from '../../../../../../core/betslip-type';
import { LINEAR_CONTAINER_STAKE_SERVICE } from '../../../../../stake/services/digital/linear/linear-container-stake.interface';
import { LINEAR_CONTAINER_SUMMARY_SERVICE } from '../../../../../summary/services/linear/linear-container-summary.interface';
import { LinearBetBuilderPickId } from '../../../../models';
import { BetBuilderContainerStakeService } from '../../../../services/bet-builder-container-stake.service';
import { BetBuilderContainerSummaryService } from '../../../../services/bet-builder-container-summary.service';

@Component({
    selector: 'bs-linear-bet-builder-pick-summary',
    templateUrl: './linear-bet-builder-pick-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NumpadService,
        BetBuilderContainerStakeService,
        BetBuilderContainerSummaryService,
        { provide: LINEAR_CONTAINER_SUMMARY_SERVICE, useExisting: BetBuilderContainerSummaryService },
        { provide: LINEAR_CONTAINER_STAKE_SERVICE, useExisting: BetBuilderContainerStakeService },
    ],
    standalone: false,
})
export class LinearBetBuilderPickSummaryComponent {
    readonly isDisabled = input<boolean>();
    readonly pickId = input.required<LinearBetBuilderPickId>();

    readonly betslipType = BetslipType.Combo;

    constructor(
        private stakeService: BetBuilderContainerStakeService,
        private summaryService: BetBuilderContainerSummaryService,
    ) {
        const changedPickId = computed(() => this.pickId(), {
            equal: (a, b) => a.toString() === b.toString(),
        });

        effect(() => {
            this.stakeService.updatePickId(changedPickId());
            this.summaryService.updatePickId(changedPickId());
        });
    }
}
